// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Ce79 text_button-label__2zMyx","filled":"Button_filled__3enrP","disabled":"Button_disabled__3pwG8"};